/**
 * Modelo de un indicador
 *
 * @export
 * @class Indicador
 */
export class Indicador {
  id: number;
  nombre: string;
  url?: string;
  descripcion?: string;
  categoria?: CategoriaIndicador; 

}

/**
 * Modelo de la consulta de categorias de indicadores
 *
 * @export
 * @class CategoriaIndicador
 */
export class CategoriaIndicador {
  id: number;
  nombre: string;
  descripcion: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/indicator.model.ts